<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-05 21:13:23
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-05 21:18:19
-->
<template>
  <div class="flex-row flex-align-center">
    <span class="contact-img"><img :src="item.avatar_url" alt=""></span>
    <span class="contact-name">{{ item.nick_name }}</span>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>
<style lang="less" scoped>
.contact-img{
    float: left;
    width: 30px;
    height: 30px;
}
.contact-img img {
    border-radius: 50%;
}
.contact-name{
    float: left;
    color: #8492a6;
    margin-left: 10px;
}
</style>